import { render, staticRenderFns } from "./LoversCustom.vue?vue&type=template&id=0bf5abdb&scoped=true"
import script from "./LoversCustom.vue?vue&type=script&lang=js"
export * from "./LoversCustom.vue?vue&type=script&lang=js"
import style0 from "./LoversCustom.vue?vue&type=style&index=0&id=0bf5abdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5abdb",
  null
  
)

export default component.exports